import Styled from 'styled-components'

export default Styled.div`

  width: 100%;
  padding: 0 2.2rem 10rem;
  line-height: 30px;

div.Navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 1rem 2rem 1.5rem;
  a {
    border: 1px solid;
    outline: none;
    font-size: 0.8rem;
    font-weight: 600;
    padding: 0.8rem;
    border-radius: 25px;
    text-decoration: none;
    color: #000;
  }
}

 button.GoBackButton {
  border: 1px solid;
  outline: none;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0.5rem 1.5rem 0.4rem;
  border-radius: 100px;
}

h1.Header {
font - size: 2.4rem;
line - height: 50px;
font - weight: 900;
margin: 2rem 0rem 2rem;
}

h1.SecurityHeader {
  margin: 2rem 0rem 2rem;
  font-weight: 900;
  font-size: 3rem;
  line-height: 68px;
}

div.IconContainer {
  margin: 2rem 0rem 4rem 2rem;
}
h5.LastUpdated {
font - size: 0.8rem;
font - weight: 500;
color: #00d0be;
}
h5.SecurityLastUpdated {
  font-size: 0.8rem;
  font-weight: 500;
  color: #00d0be;
}


li.Section {
  display: block;
  margin-bottom: 2.5rem;
}

div.SecuritySection {
  display: block;
  margin-bottom: 5.5rem;

  &#bottom {
    margin: 10rem 0rem;
    p {
      font-size: 0.969rem;
    }
  }
  &.borderBottom {
    padding-bottom: 5.5rem;
    border-bottom: 1px dotted #e1e4e4;
  }
}

h3.SectionTitle{
font - size: 1.4rem;
font - weight: 700;
margin - bottom: 1.3rem;
}

h3.SecuritySectionTitle{
  font-size: 1.5rem;
  font-weight: 800;
  margin-bottom: 1.3rem;
  display: flex;
  span {
    margin-right: 20px;
  }
  span:nth-child(2) {
    margin-right: 0px;
  }
}

p.SectionParagraph {
font - size: 0.85rem;
font - weight: 500;
margin: 0rem 0rem 1rem;
}
p.SecuritySectionParagraph {
  font-size: 1.075rem;
  font-weight: 500;
  margin: 0rem 0rem 1rem;
  color: #003333;
  line-height: 30px;
  &.security {
    color: #000;
    font-weight: 500;
    font-size: 0.969rem;
    margin-bottom: 2rem;
  }
}
`